module.exports = __webpack_public_path__ + "3e5a3a107a772a878134c414d66272a5.MP3";